export const call = (callback)=>{
    try {
        callback();
    } catch (e) {
        console.log(e)
    }
}
